import { gql } from "@apollo/client"
import { TierFeaturesSectionApplylistFragment } from "@pallet/features/ApplylistType/components/PartnershipTierFeaturesSection/fragment"
import { ContingencyTierOverviewSectionApplylistFragment } from "@pallet/features/ApplylistType/components/PartnershipTierOverviewSection/variants/Contingency/fragment"
import { ContingencyCtaApplylistFragment } from "@pallet/features/ApplylistType/components/ContingencyTierCta/fragments"

export const ContingencyTierSelectorItemApplylistFragment = gql`
    fragment ContingencyTierSelectorItem_applylist on ApplylistType {
        id
        ...TierFeaturesSectionApplylist
        ...ContingencyTierOverviewSection_applylist
        ...ContingencyCta_applylist
    }
    ${TierFeaturesSectionApplylistFragment}
    ${ContingencyTierOverviewSectionApplylistFragment}
    ${ContingencyCtaApplylistFragment}
`
